class PermissionsService {
  constructor() {
    this.permissions = {}
  }

  setPermissions(permissions) {
    this.permissions = permissions || {}
  }

  hasPermission(key) {
    return this.permissions[key] === "1"
  }

  hasAnyPermission(keys = []) {
    return keys.some((key) => this.hasPermission(key))
  }

  hasAllPermissions(keys = []) {
    return keys.every((key) => this.hasPermission(key))
  }
}

const permissionsService = new PermissionsService()

export default {
  install(app) {
    app.provide("permissionsService", permissionsService)
    app.directive("has-permission", {
      mounted(el, binding) {
        if (!permissionsService.hasPermission(binding.value)) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    })
  }
}

export { permissionsService }
